import { Text, View } from "@react-pdf/renderer";
import { parseDate } from "helpers/date";
import { isEmpty } from "lodash";

import { styles } from "../styles";

export function PatientInfoDefault({
  name,
  dateOfBirth,
  payerName,
  serviceDate,
  isGFE,
  accountNumber,
  uniqueProcedureList,
  style,
}: {
  name: string;
  dateOfBirth: string;
  payerName: string;
  serviceDate: string;
  isGFE: boolean;
  accountNumber?: string;
  uniqueProcedureList: any[];
  style?: any;
}) {
  return (
    <View
      style={{
        marginLeft: 50,
        marginRight: 50,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 20,
        ...style,
      }}
    >
      <View style={{ marginTop: 0, marginBottom: 0, width: "50%" }}>
        <View
          style={{
            display: "flex",
            marginBottom: "3px",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text style={{ ...styles.listTitle, width: 100 }}>Patient</Text>
          <Text style={styles.smallText}>{`${name}`}</Text>
        </View>
        <View
          style={{
            display: "flex",
            marginBottom: "3px",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text style={{ ...styles.listTitle, width: 100 }}>Date of Birth</Text>
          <Text style={styles.smallText}>{parseDate(dateOfBirth)}</Text>
        </View>
        {!isEmpty(payerName) && (
          <View
            style={{
              display: "flex",
              marginBottom: "3px",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Text style={{ ...styles.listTitle, width: 100 }}>Payer</Text>
            <Text style={styles.smallText}>{`${payerName}`}</Text>
          </View>
        )}
        <View
          style={{
            display: "flex",
            marginBottom: "3px",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Text style={{ ...styles.listTitle, width: 100 }}>Service Date</Text>
          <Text style={styles.smallText}>{`${parseDate(serviceDate)}`}</Text>
        </View>
        {isGFE && (
          <View
            style={{
              display: "flex",
              marginBottom: "3px",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Text style={{ ...styles.listTitle, width: 100 }}>
              Account number
            </Text>
            <Text style={styles.smallText}>{accountNumber}</Text>
          </View>
        )}
      </View>
      <View
        style={{
          marginTop: 0,
          marginBottom: 0,
          display: "flex",
          flexDirection: "column",
          width: "50%",
        }}
      >
        <Text style={{ ...styles.listTitle, marginBottom: 4 }}>
          Services Provided
        </Text>
        {uniqueProcedureList.map((currentProcedure) => (
          <Text
            style={{ ...styles.itemList, marginBottom: 3 }}
            key={currentProcedure.code}
          >
            {currentProcedure.cptDescription} - {currentProcedure.code}
          </Text>
        ))}
      </View>
    </View>
  );
}
